import { TrackingShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/TrackingShipmentState";

export function trackingResolveRedirectPath(
  trackingType: TrackingShipmentState,
  id: string,
): string {
  switch (trackingType) {
    case TrackingShipmentState.Draft:
      return `/book/draft?shipmentDraftId=${id}`;
    case TrackingShipmentState.Quoted:
      return `/book/quotes?shipmentId=${id}`;
    case TrackingShipmentState.QuoteSelected:
      return `/book/pickup-address?shipmentId=${id}`;
    case TrackingShipmentState.ReviewPriorBooking:
      return `/book/review?shipmentId=${id}`;
    case TrackingShipmentState.Booked:
      return `/view-shipment?shipmentId=${id}`;
  }
}
